/**
 * Ambient module types run alongside whatever module is active: they never
 * appear in the module list, are never the "active module" and have no
 * completion state. Both workspace pages filter them out of the interactive
 * module list and render their UI elsewhere (left-rail timer, right-rail
 * Voice tab).
 */
export const AMBIENT_MODULE_TYPES = new Set(["annotation_time", "voice_note"])

export function isAmbientModuleType(templateType: string): boolean {
  return AMBIENT_MODULE_TYPES.has(templateType)
}
